import A from './components/A';
import B from './components/B';
import css from './index.module.scss';

export default function Overview({}: any) {
    return (
        <div className={`ef-collection-h5 ${css.efCollectionH5}`}>
            <A />
            <B />
        </div>
    );
}
